module.exports = __webpack_public_path__ + "static/00008.57966cfb.jpg";